/*
Utilities to display the German status instead of the value from JSON
To be replaced by transpiled Java function
 */

export const StatusMap = {
  ERROR: 'Fehler',
  FINISHED: 'Fertig',
  QUEUED: 'Wartet',
  ACTIVE: 'Aktiv',
  READY: 'Bereit',
};
